import axios, { AxiosResponse } from 'axios';

import { authFetch } from '.';
import { IAgentCommission } from '../models';
import { ILookupType } from '../models/employee';

const baseUrl = '/api/Admin/AgentCommission';

export const IAgentCommissionAPI = {
  /**
   * Fetch the latest list of all agent commissions.
   */
  async getAll(): Promise<IAgentCommission[]> {
    try {
      const response: AxiosResponse<IAgentCommission[]> = await authFetch.get(`${baseUrl}`);

      // Check if status is in the 2XX range
      if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText);
      }

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  /**
   * Create and update an array of given records.
   */
  async upsert(records: IAgentCommission[]): Promise<IAgentCommission[]> {
    try {
      const response: AxiosResponse<IAgentCommission[]> = await authFetch.post(
        `${baseUrl}`,
        records
      );

      // Check if status is in the 2XX range
      if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText);
      }

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async delete(commissionTierId: number): Promise<void> {
    try {
      const response = await authFetch.delete(`${baseUrl}/${commissionTierId}`);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async getTablesLookup() : Promise<ILookupType[]> {
    try {
      const response: AxiosResponse<ILookupType[]> = await authFetch.get(`${baseUrl}/table`);

      if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText);
      }
      return response.data;
    }catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  }
};
